import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';

interface IImageZoomModalProps {
  src: string;
  onClose: () => void;
}

export const ImageZoomModal = ({ src, onClose }: IImageZoomModalProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 10);

    return () => clearTimeout(timer);
  }, []);

  return createPortal(
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-300 ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setVisible(false);
          setTimeout(onClose, 200);
        }
        e.stopPropagation();
      }}
    >
      <div className="relative">
        <button
          onClick={(e) => {
            setVisible(false);
            setTimeout(onClose, 200);
            e.stopPropagation();
          }}
          className="absolute top-4 right-4 z-50 w-6 h-6 flex items-center justify-center text-white text-2xl rounded-full"
          style={{ backgroundColor: 'rgba(0, 0, 0, 1)' }}
          aria-label="Close image modal"
        >
          ×
        </button>
        <img
          src={src}
          alt="Zoomed"
          className={`w-auto h-auto max-w-[90vw] max-h-[90vh] transform transition-transform duration-300 rounded-[20px] ${
            visible ? 'scale-100' : 'scale-95'
          }`}
        />
      </div>
    </div>,
    document.body,
  );
};
